import TextStyle from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/textStyle.mdx";
import BlockStyle from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/blockStyle.mdx";
import FontFaces from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/fontFaces.mdx";
import Stylesheets from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/stylesheets.mdx";
import LoadingScreen from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/loadingScreen.mdx";
import Input from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/input.mdx";
import InputBase from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputBase.mdx";
import InputError from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputError.mdx";
import InputLabel from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputLabel.mdx";
import InputErrorText from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputErrorText.mdx";
import FormSpacings from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/formSpacings.mdx";
import ShowMorePaymentMethodsButton from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/showMorePaymentMethodsButton.mdx";
import ShowMorePaymentMethodsButtonStyles from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/showMorePaymentMethodsButtonStyles.mdx";
import NetworkError from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/networkError.mdx";
import SubmitButton2 from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/submitButton2.mdx";
import SubmitButtonStyles from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/submitButtonStyles.mdx";
import SavedPaymentMethodButton from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/savedPaymentMethodButton.mdx";
import SavedPaymentMethodButtonStyles from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/savedPaymentMethodButtonStyles.mdx";
import PaymentMethodButton2 from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/paymentMethodButton2.mdx";
import ErrorMessage2 from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/errorMessage2.mdx";
import SmallPrint from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/smallPrint.mdx";
import VaultTitle from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/vaultTitle.mdx";
import PrimaryText from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/primaryText.mdx";
import * as React from 'react';
export default {
  TextStyle,
  BlockStyle,
  FontFaces,
  Stylesheets,
  LoadingScreen,
  Input,
  InputBase,
  InputError,
  InputLabel,
  InputErrorText,
  FormSpacings,
  ShowMorePaymentMethodsButton,
  ShowMorePaymentMethodsButtonStyles,
  NetworkError,
  SubmitButton2,
  SubmitButtonStyles,
  SavedPaymentMethodButton,
  SavedPaymentMethodButtonStyles,
  PaymentMethodButton2,
  ErrorMessage2,
  SmallPrint,
  VaultTitle,
  PrimaryText,
  React
};